import React, { useEffect } from 'react';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import './nav-header-filters.scss';
import VideoHlroomAnalytics from '@sky-it-video/hlroom-analytics';

import { ChipHeader } from '../../atoms';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import useDrag from '../../../hooks/useDrag';
import { ISubSection } from '../../../typings/hlroom';

export interface INavHeaderFilters {
  isDesktop: boolean;
  subSections: ISubSection[];
  subSectionIndex: number;
  onSubSectionChange: (value: ISubSection) => void;
  showFilters: boolean;
  appType?: string;
}
type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

const NavHeaderFilters: React.FC<INavHeaderFilters> = ({
  isDesktop = false,
  subSections,
  subSectionIndex,
  onSubSectionChange,
  showFilters,
  appType = 'sport',
}) => {
  const { dragStart, dragStop, dragMove, dragging } = useDrag();
  const apiRef = React.useRef({} as scrollVisibilityApiType);

  useEffect(() => {
    if (apiRef.current) {
      const el = apiRef.current?.getItemElementByIndex(subSectionIndex) as Element;
      apiRef.current?.scrollToItem?.(el);
    }
  }, [subSections, subSectionIndex]);

  const handleDrag =
    ({ scrollContainer }: any) =>
    (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });

  const classNames = (isDesktop: boolean): IClassNames =>
    makeClassNames({
      navHeaderFilters: [
        'nav-header-filters',
        showFilters && !isDesktop && appType === 'sport' && 'nav-header-filters--hide',
        isDesktop && 'nav-header-filters__desktop',
      ],
      navHeaderSliderContainer: 'nav-header-filters__container',
      navHeaderSliderWrapper: 'nav-header-filters__wrapper',
    });

  const cn = classNames(isDesktop);

  const clickOnChip = (subSection: ISubSection) => {
    if (dragging) {
      return false;
    }

    VideoHlroomAnalytics.setDigitalData(
      {
        zoneid: { subSection: !subSection?.tag ? 'tutti' : subSection?.tag?.replace(' ', '-') },
      },
      appType
    );
    onSubSectionChange(subSection);
    window.scrollTo(0, 0);
    return false;
  };

  return (
    <div className={cn.navHeaderFilters} onMouseLeave={dragStop}>
      <ScrollMenu
        scrollContainerClassName={cn.navHeaderSliderContainer}
        onMouseDown={() => dragStart}
        onMouseUp={() => dragStop}
        onMouseMove={handleDrag}
        wrapperClassName={cn.navHeaderSliderWrapper}
        apiRef={apiRef}
      >
        {subSections.map((subSection, i) => (
          <ChipHeader
            itemId={i}
            onClick={() => clickOnChip(subSection)}
            key={`ch_ss_${subSection.tag}`}
            text={subSection.name}
            isSelected={subSections[subSectionIndex]?.tag === subSection.tag}
            isDesktop={isDesktop}
          />
        ))}
      </ScrollMenu>
    </div>
  );
};

export default NavHeaderFilters;
